import Swiper from 'swiper';
import { FreeMode, Navigation } from 'swiper/modules';
import 'swiper/modules/free-mode.scss';
import 'swiper/swiper.scss';

document.addEventListener('DOMContentLoaded', () => {
  const reviews = document.querySelectorAll('.js-reviews');

  const reviews_carousel = () => {
    reviews.forEach(review => {
      new Swiper(review, {
        modules: [FreeMode, Navigation],
        createElements: true,
        freeMode: true,
        navigation: {
          nextEl: review.parentNode.querySelector('.swiper-button-next'),
          prevEl: review.parentNode.querySelector('.swiper-button-prev')
        },
        slidesPerView: 'auto',
        speed: 500
      });
    });
  };

  window.carousels = () => {
    reviews ? reviews_carousel() : false;
  }
}, false)
